(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Crousel_reels"] && !Shopify.designMode) return;
  try {
    
function attachMuteButtons() {
  document.querySelectorAll(".reel-video-wrapper").forEach(wrapper => {
    const video = wrapper.querySelector("video");
    const btn = wrapper.querySelector(".mute-toggle");

    if (video && btn) {
      // Set correct icon on load
      btn.textContent = video.muted ? "🔇" : "🔊";

      // Remove previous listener
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener("click", () => {
        video.muted = !video.muted;
        newBtn.textContent = video.muted ? "🔇" : "🔊";
        video.play().catch(() => {});
      });
    }
  });
}

// Run after full page load
document.addEventListener("DOMContentLoaded", function () {
  attachMuteButtons();

  // Optional: Run again in case of Shopify Section reloading
  document.addEventListener("shopify:section:load", function () {
    attachMuteButtons();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Instagram-Reels-Style-Videos"] && !Shopify.designMode) return;
  try {
    
function attachMuteButtons() {
  document.querySelectorAll(".reel-video-wrapper").forEach(wrapper => {
    const video = wrapper.querySelector("video");
    const btn = wrapper.querySelector(".mute-toggle");

    if (video && btn) {
      // Set correct icon on load
      btn.textContent = video.muted ? "🔇" : "🔊";

      // Remove previous listener
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener("click", () => {
        video.muted = !video.muted;
        newBtn.textContent = video.muted ? "🔇" : "🔊";
        video.play().catch(() => {});
      });
    }
  });
}

// Run after full page load
document.addEventListener("DOMContentLoaded", function () {
  attachMuteButtons();

  // Optional: Run again in case of Shopify Section reloading
  document.addEventListener("shopify:section:load", function () {
    attachMuteButtons();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
